import { useQuery } from '@tanstack/react-query';
import { courseAppearanceService } from '@/services/course-appearance.service';
import { appearanceKeys } from './queryKeys';

export function usePageSections(productId: string, enabled = true) {
  return useQuery({
    queryKey: appearanceKeys.sections(productId),
    queryFn: () => courseAppearanceService.getPageSections(productId),
    enabled: enabled && !!productId,
  });
}
